import { render, staticRenderFns } from "./AdminViewFirstTimers.vue?vue&type=template&id=bf24aeac&scoped=true&"
import script from "./AdminViewFirstTimers.vue?vue&type=script&lang=js&"
export * from "./AdminViewFirstTimers.vue?vue&type=script&lang=js&"
import style0 from "./AdminViewFirstTimers.vue?vue&type=style&index=0&id=bf24aeac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf24aeac",
  null
  
)

export default component.exports